import { memo } from "react";
import { useTheme } from "../../hooks/useTheme";
import { handleLinkPressed } from "@markit/common.utils";
import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";
import { AccountData } from "@markit/common.types";
import ProfilePic from "../ProfilePic";

type FullEventHostsProps = {
  final?: boolean;
  showUsername?: boolean;
  host: AccountData | undefined;
  hostAndCohosts: AccountData[];
};

const FullEventHosts = memo(function FullEventHostsFn(
  props: FullEventHostsProps
) {
  const { final, showUsername, host, hostAndCohosts } = props;

  const { theme } = useTheme();

  return (
    <>
      {host && (
        <div className="Guests">
          {hostAndCohosts.map((guest, index) => (
            <div key={index} className="GuestLine">
              <a href={`/u/${guest.username}`} className="HostCohostListLink">
                <div className="GuestInfo">
                  <ProfilePic user={guest} size={final ? 38 : 30} />
                  <div>
                    <div
                      style={{
                        ...theme.PrimaryText,
                        fontSize: final ? 14 : 16,
                        fontWeight: "500",
                        cursor: "pointer",
                        marginBottom: final ? 2 : 0,
                      }}
                    >
                      {guest.fullName}
                    </div>
                    <div
                      className="HostCohostsHeader"
                      style={{ fontSize: final ? 12 : 13 }}
                    >
                      {showUsername
                        ? `@${guest.username}`
                        : index === 0
                        ? "Host"
                        : "Cohost"}
                    </div>
                  </div>
                </div>
              </a>
              <div className="AlignedRow" style={{ gap: "7px" }}>
                {guest.instagram && (
                  <div
                    className="ProfileBrowserSocialMediaIcon"
                    onClick={() =>
                      window.open(
                        handleLinkPressed("instagram", guest.instagram),
                        "_blank"
                      )
                    }
                  >
                    <Icon
                      icon="mdi:instagram"
                      height={18}
                      style={{ color: Colors.GRAY2 }}
                    />
                  </div>
                )}
                {guest.twitter && (
                  <div
                    className="ProfileBrowserSocialMediaIcon"
                    onClick={() =>
                      window.open(
                        handleLinkPressed("twitter", guest.twitter),
                        "_blank"
                      )
                    }
                  >
                    <Icon
                      icon="ri:twitter-x-fill"
                      height={18}
                      style={{
                        paddingBottom: 1.5,
                        color: Colors.GRAY2,
                      }}
                    />
                  </div>
                )}
                {guest.linkedin && (
                  <div
                    className="ProfileBrowserSocialMediaIcon"
                    onClick={() =>
                      window.open(
                        handleLinkPressed("linkedin", guest.linkedin),
                        "_blank"
                      )
                    }
                  >
                    <Icon
                      icon="ri:linkedin-fill"
                      height={18}
                      style={{
                        paddingBottom: 1.5,
                        color: Colors.GRAY2,
                      }}
                    />
                  </div>
                )}
                {guest.tiktok && (
                  <div
                    className="ProfileBrowserSocialMediaIcon"
                    onClick={() =>
                      window.open(
                        handleLinkPressed("tiktok", guest.tiktok),
                        "_blank"
                      )
                    }
                  >
                    <Icon
                      icon="ic:baseline-tiktok"
                      height={18}
                      style={{
                        paddingBottom: 1,
                        color: Colors.GRAY2,
                      }}
                    />
                  </div>
                )}
                {guest.spotify && (
                  <div
                    className="ProfileBrowserSocialMediaIcon"
                    onClick={() =>
                      window.open(
                        handleLinkPressed("spotify", guest.spotify),
                        "_blank"
                      )
                    }
                  >
                    <Icon
                      icon="mdi:spotify"
                      height={18}
                      style={{ color: Colors.GRAY2 }}
                    />
                  </div>
                )}
                {guest.youtube && (
                  <div
                    className="ProfileBrowserSocialMediaIcon"
                    onClick={() =>
                      window.open(
                        handleLinkPressed("youtube", guest.youtube),
                        "_blank"
                      )
                    }
                  >
                    <Icon
                      icon="ion:logo-youtube"
                      height={18}
                      style={{ color: Colors.GRAY2 }}
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
});

export default FullEventHosts;
